<template>
  <div class="w-full">
    <div
      class="model flex items-center w-full mb-6"
      @click="openDetail"
    >
      <div class="w-4/5 cursor-pointer">
        <span v-if="value !== null">{{ value }}</span>
        <span v-if="value === null">{{ placeholder }}</span>
      </div>
      <div class="w-1/5 flex justify-end">
        <svg-icon
          name="ic_form_down"
          class="h-3 cursor-pointer "
          original
        />
      </div>
    </div>

    <divider
      class=""
      height="1px"
      color="#5F01D3"
    />

    <div class="blocDefil">
      <div
        v-if="position !== null && index !== null && index === position"
        class="detail p-4 pt-1"
      >
        <div
          v-for="(item, index) in option"
          :key="index"
          class="cursor-pointer"
          @click="selected(index)"
        >
          <div
            class="mt-3"
          >
            {{ item }}
          </div>

          <divider
            v-if="index < option.length - 1"
            class="mt-4"
            :height="diviserHeight"
            :color="diviserColor"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    divider
  },
  props: {
    option: {
      type: Array,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Civilité'
    },
    index: {
      type: Number,
      default: null
    },
    position: {
      type: Number,
      default: null
    },
    diviserHeight: {
      type: String,
      default: '1px'
    },
    diviserColor: {
      type: String,
      default: 'rgba(255, 255, 255, 0.2)'
    }
  },
  data () {
    return {
      activeDetail: false,
      selectedItem: null
    }
  },
  computed: {

  },
  methods: {
    selected (index) {
      this.value = this.option[index]
      this.$emit('info', this.value)
      this.activeDetail = false
    },
    openDetail () {
      this.activeDetail = !this.activeDetail
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";

.model{
  font-weight: 600;
  font-size: 14.1603px;
  line-height: 17px;
  color: $form-text;
}
.detail{
  background-color: $devs_color;
  color: $white;
  font-weight: 600;
  font-size: 18.8804px;
  line-height: 23px;
  width: 40%;
}

.blocDefil{
  position: absolute;
  z-index: 1;
  width: 100%;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.svg-fill{
  fill: white;
}
</style>
